import React, { useMemo } from 'react';
import { Slider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { makeStyles } from '@mui/styles';

import { Text, View } from '../Base';
import palette from '../styles/palette';

const STEP = 5;
const MINUTES_IN_DAY = 1439;

const useStyles = makeStyles(() => ({
  root: {
    padding: '4px 16px 10px 10px',
    display: 'flex',
    flexDirection: 'column',

    '& .MuiSlider-root': {
      padding: '0',
      marginBottom: '0px',
      color: palette.white,
      height: '2px',
    },
    '& .MuiSlider-thumb': {
      height: '12px',
      width: '12px',
      backgroundColor: palette.white,
      boxShadow: 'none',
      '&.Mui-active': {
        boxShadow: 'none',
      },
    },
  },
  labelContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    color: palette.white,
    fontWeight: 500,
    alignItems: 'center',
    marginBottom: '8px',
  },
  title: {
    fontSize: '12px',
    fontWeight: 500,
    marginRight: '5px',
  },
  label: {
    fontSize: '10px',
    fontWeight: 500,
  },
}));

const formatMinutesToTime = (minutes) =>
  dayjs().startOf('day').add(minutes, 'minute').format('hh:mm A');

const TimeRangeSliderWithEvents = ({
  onTimeRangeChange,
  eventTimes,
  timeRange,
}) => {
  const classes = useStyles();

  const handleChange = (event, newValue) => {
    event.preventDefault();
    event.stopPropagation();
    onTimeRangeChange(newValue);
  };

  const eventMarks = useMemo(
    () =>
      eventTimes.map((min) => ({
        value: min,
      })),
    [eventTimes]
  );

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <View className={classes.root}>
        <View className={classes.labelContainer}>
          <Text className={classes.title}>Time:</Text>
          <Text className={classes.label}>
            {formatMinutesToTime(timeRange[0])} –{' '}
            {formatMinutesToTime(timeRange[1])}
          </Text>
        </View>

        <Slider
          value={timeRange}
          onChange={handleChange}
          min={0}
          max={MINUTES_IN_DAY}
          step={STEP}
          marks={eventMarks}
          valueLabelDisplay="off"
          sx={{
            '& .MuiSlider-mark': {
              backgroundColor: palette.dpdRed,
              height: 4,
              width: 4,
              borderRadius: 1,
            },
          }}
        />
      </View>
    </LocalizationProvider>
  );
};

export default TimeRangeSliderWithEvents;
